import React, { Component } from 'react'
import styled from '@emotion/styled'
import { colors, typography, animations } from 'src/styles'
import Link from 'src/components/Link'
import NavUnderline from 'src/assets/images/nav-underline-2.svg'

const NavLinkUnderline = styled(NavUnderline)`
  display: block;
  position: absolute;
  bottom: 0;
  left: -.35em;
	width: calc(100% + .35em + .5em);
  overflow: visible;
  height: 8px;
  * {
    fill: currentcolor;
    // stroke: ${ colors.mainColor };
		// stroke: var(--main-color);
    transition: fill ${ animations.mediumSpeed } ease-in-out;
  }
  ${ ({ active }) => active ? `
    fill: var(--main-color);
  ` : '' }

`

const StyledLinkText = styled.div`
	position: relative;
	display: inline-block;
	padding-bottom: calc(8px + .5em);
	~ {
		stroke: inherit;
	}

	// &:after {
	// 	content: '';
	// 	display: block;
	// 	position: absolute;
	// 	top: 100%;
	// 	left: 0;
	// 	width: 100%;
	// 	height: 2px;
	// 	background: ${ ({ theme }) => colors[theme] };
	// 	transform: scaleX(0);
	// 	transform-origin: right center;
	// 	transition: transform ${ animations.mediumSpeed } ease-in-out;
	// }
	// &:hover {
	// 	&:after {
	// 		transform-origin: left center;
	// 		transform: scaleX(1);
	// 	}
	// }
`

const TextLinkWrapper = styled(Link)`
	position: relative;
	${ typography.buttonStyle }
	display: inline-block;
	&:hover {
    ${ NavLinkUnderline } {
      * {
        fill: var(--main-color);
      }
    }
  }
`

class TextLink extends Component {
	render () {
		const {
			to,
			external,
			target,
			loading,
			error,
			success,
			disabled,
			onClick,
			theme = 'currentcolor',
			className,
			children,
			title,
			active = false
		} = this.props

		return (
			<TextLinkWrapper
				className={className}
				to={to}
				target={target}
				external={external}
				loading={loading}
				error={error}
				success={success}
				disabled={disabled}
				onClick={onClick}
				theme={theme}
				title={title}
			>
				<StyledLinkText>
					{children}
				</StyledLinkText>
				<NavLinkUnderline active={active}/>
			</TextLinkWrapper>
		)
	}
}

export default TextLink
